import { render, staticRenderFns } from "./editPromoVoucherPaymentOption.vue?vue&type=template&id=28005ab6&lang=pug"
import script from "./editPromoVoucherPaymentOption.vue?vue&type=script&lang=js"
export * from "./editPromoVoucherPaymentOption.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports